const SET_LIST = (state, obj) => {
  state.list = obj.data
}

export default {
  SET_LIST
}



// WEBPACK FOOTER //
// ./src/features/admin/tiposUsuarios/store/mutations.js